module.exports = __webpack_public_path__ + "static/media/orange-l.624ac1f6.svg";